<template>
  <div class="fabric-wrapper">
    <el-card
      class="box-card"
      shadow="never"
      v-for="item in table"
      :key="item.resFabricScmImageCode"
      :body-style="{ padding: '3px 0 0 3px' }"
      style="border:none;margin-bottom: 10px;"
    >
      <div>
        <div
          style="display: flex;justify-content: center; align-items: center;flex-wrap: wrap;"
        >
          <div class="mt-1 mr-2">
            <el-card :body-style="{ padding: '0' }" shadow="never">
              <el-row>
                <div style="display: flex; padding: 5px;">
                  <div style="width:130px; height:130px" class="mr-2">
                    <el-image
                      :src="
                        item.thumbImageUrl
                          ? $osscdn(item.thumbImageUrl)
                          : '/image/static/img/nopic.jpg'
                      "
                      @click.stop="onImagePreview(item.listImageUrl, 0)"
                      style="width:130px; height:130px"
                    >
                      <div slot="error" class="image-slot">
                        <img
                          src="/image/static/img/nopic.jpg"
                          style="width: 130px; height: 130px"
                        />
                      </div>
                    </el-image>
                  </div>
                  <div style="width:130px; height:130px;">
                    <div class="covers">
                      <div
                        :class="
                          index == 1 || index == 4 || index == 7
                            ? 'cover-m cover'
                            : 'cover'
                        "
                        v-for="(img, index) in item.fabricInfoList"
                        :key="index"
                      >
                        <el-image
                          :src="
                            img ? $osscdn(img) : '/image/static/img/nopic.jpg'
                          "
                          @click.stop="
                            onImagePreview(item.listImageUrl, index + 1)
                          "
                          style="width:40px; height:40px"
                        >
                          <div slot="error" class="image-slot">
                            <img
                              src="/image/static/img/nopic.jpg"
                              style="width: 130px; height: 130px"
                            />
                          </div>
                        </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </el-row>
              <el-descriptions border size="small" :column="1" class="mt-1">
                <el-descriptions-item
                  :label="'面料编号'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  <span>{{ item.fabricNo || '' }}</span>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="'厂家编号'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  <span>{{ item.ftyNo || '' }}</span>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="'面料名称'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fabricName"
                    placement="top"
                  >
                    <div class="over-ellipsis">
                      {{ item.fabricName || '' }}
                    </div>
                  </el-tooltip>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="'克重/门幅'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  <div class="fabriWid-Weight">
                    <div>
                      <span> {{ item.fabricWeight || '' }}</span>
                      <span> {{ item.fabricWeightUnit || '' }}</span>
                    </div>
                    <div>
                      <span> {{ item.fabricWid || '' }}</span>
                      <span> {{ item.widUnit || '' }}</span>
                    </div>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="'面料成分'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fabricContent"
                    placement="top"
                  >
                    <div class="over-ellipsis">
                      {{ item.fabricContent || '' }}
                    </div>
                  </el-tooltip>
                </el-descriptions-item>
                <el-descriptions-item
                  :label="'价格'"
                  :labelStyle="{ width: '75px', fontSize: '14px' }"
                  :contentStyle="{
                    width: '150px',
                    color: '#101010;',
                    fontSize: '14px',
                  }"
                >
                  {{ item.unitPrice || '' }} {{ item.fabricUnit || '' }}
                </el-descriptions-item>
              </el-descriptions>
              <div class="c-f-button">
                <div class="br-1" @click="like(item)" v-if="item.isLike == '0'">
                  <b-icon icon="heart"></b-icon>
                  Like
                </div>
                <div class="br-1" @click="like(item)" v-else>
                  <b-icon style="color: red;" icon="heart-fill"></b-icon>
                  Like
                </div>
                <div @click="openAddCart(item)">
                  <i class="el-icon-shopping-cart-2"></i>
                  Add to Cart
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-card>
    <add-cart
      :visible.sync="addCartOptions.visible"
      :resFabricInfoCode="addCartOptions.code"
      :resFabricScmCode="addCartOptions.resFabricScmCode"
      @close="close"
    ></add-cart>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'
import addCart from '../add-cart'

export default {
  mixins: [EditLoading, BaseTable],
  components: { addCart },
  props: {
    table: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      title: '',
      addCartOptions: {
        visible: false,
        code: '',
        resFabricScmCode: '',
      },
      listImageUrl: [],
    }
  },
  mounted() {},
  methods: {
    openAddCart(item) {
      const { resFabricScmCode, resFabricInfoCode } = item
      this.addCartOptions.code = resFabricInfoCode
      this.addCartOptions.resFabricScmCode = resFabricScmCode
      this.addCartOptions.visible = true
    },
    like(item) {
      this.$api
        .resFabricDemandLikeApi({
          resFabricInfoCode: item.resFabricInfoCode,
        })
        .then(() => {
          this.$emit('reset')
        })
    },
    close(){
      this.$emit("getCardCount")
    },
    reset() {
      this.$emit('reset')
    },
    onImagePreview(imgList, index) {
      if (!imgList && !imgList.length) return
      this.listImageUrl = imgList
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  justify-content: space-around;
  margin-bottom: 20px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}

::v-deep {
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 2px 0 0 0;
  }
  .el-descriptions-item__label {
    border-left: none !important;
  }
  .el-descriptions-item__content {
    border-right: none !important;
  }
}
.c-f-button {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  cursor: pointer;
  svg,
  i {
    margin-right: 7px;
  }
  i {
    font-size: 16px;
  }
  .br-1 {
    border-right: 1px solid #efefef;
  }
  div {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
.covers {
  display: flex;
  flex-wrap: wrap;
  .cover-m {
    margin: 0 4px;
  }
}
.cover {
  display: flex;
  justify-content: center;
  width: 40px;
  margin-bottom: 5px;
}
.border-detail-main-form {
  margin-top: -1px;
}
.fabriWid-Weight {
  display: flex;
  justify-content: space-between;
  margin-right: 50px;
}
.over-ellipsis {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
